"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "roccadaspide": {
    "5b6ebdbe": [{
      "hkey": "a86578c4",
      "slug": "roccadaspide",
      "name": "Roccadaspide",
      "primary": true,
      "skipSearch": false
    }],
    "doglie": [{
      "hkey": "a86578c4",
      "slug": "roccadaspide",
      "name": "Roccadaspide",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "741ceb5e": [{
      "hkey": "a86578c4",
      "slug": "roccadaspide",
      "name": "Roccadaspide",
      "primary": true,
      "skipSearch": false
    }],
    "isca": [{
      "hkey": "a86578c4",
      "slug": "roccadaspide",
      "name": "Roccadaspide",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "28fcd07a": [{
      "hkey": "a86578c4",
      "slug": "roccadaspide",
      "name": "Roccadaspide",
      "primary": true,
      "skipSearch": false
    }],
    "massano": [{
      "hkey": "a86578c4",
      "slug": "roccadaspide",
      "name": "Roccadaspide",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3c55bd40": [{
      "hkey": "37f26cf7",
      "slug": "serra-casalotti",
      "name": "Serra-Casalotti",
      "primary": true,
      "skipSearch": false
    }],
    "casalotti": [{
      "hkey": "37f26cf7",
      "slug": "serra-casalotti",
      "name": "Serra-Casalotti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roccadaspide"
    }],
    "2d3bbf38": [{
      "hkey": "37f26cf7",
      "slug": "serra-casalotti",
      "name": "Serra-Casalotti",
      "primary": true,
      "skipSearch": false
    }],
    "serra": [{
      "hkey": "37f26cf7",
      "slug": "serra-casalotti",
      "name": "Serra-Casalotti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "76f5606d": [{
      "hkey": "abab04f6",
      "slug": "templata-terzerie",
      "name": "Templata-Terzerie",
      "primary": true,
      "skipSearch": false
    }],
    "tempalta": [{
      "hkey": "abab04f6",
      "slug": "templata-terzerie",
      "name": "Templata-Terzerie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "864f0979": [{
      "hkey": "abab04f6",
      "slug": "templata-terzerie",
      "name": "Templata-Terzerie",
      "primary": true,
      "skipSearch": false
    }],
    "terzerie": [{
      "hkey": "abab04f6",
      "slug": "templata-terzerie",
      "name": "Templata-Terzerie",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "roccadaspide"
    }]
  }
};
exports["default"] = _default;